import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './Dashboard.css';

const Cubes = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
          <h1>🧱 نظام إدارة المكعبات</h1>
        </div>

        <div className="dashboard-main">
          <style>{`
            .cubes-container {
              padding: 20px;
              max-width: 1400px;
              margin: 0 auto;
            }

            .cubes-intro {
              background: white;
              padding: 30px;
              border-radius: 16px;
              box-shadow: 0 4px 20px rgba(0,0,0,0.08);
              margin-bottom: 30px;
              border-right: 6px solid #2563eb;
              animation: slideDown 0.5s ease-out;
            }

            .cubes-intro h2 {
              font-size: 28px;
              font-weight: 800;
              color: #1e293b;
              margin: 0 0 12px 0;
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .cubes-intro p {
              font-size: 16px;
              color: #64748b;
              margin: 0;
              line-height: 1.6;
            }

            .cubes-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
              gap: 24px;
              animation: fadeIn 0.6s ease-out 0.2s both;
            }

            .cube-card {
              position: relative;
              background: white;
              border-radius: 20px;
              padding: 0;
              box-shadow: 0 8px 30px rgba(0,0,0,0.12);
              transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
              overflow: hidden;
              cursor: pointer;
              border: 2px solid transparent;
            }

            .cube-card:hover {
              transform: translateY(-8px);
              box-shadow: 0 20px 50px rgba(0,0,0,0.2);
              border-color: currentColor;
            }

            .cube-card-header {
              padding: 32px 28px 24px;
              position: relative;
              overflow: hidden;
            }

            .cube-card-header::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 5px;
              background: var(--card-gradient);
            }

            .cube-card-icon {
              font-size: 56px;
              margin-bottom: 16px;
              display: block;
              animation: bounce 2s infinite;
              filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
            }

            .cube-card-title {
              font-size: 26px;
              font-weight: 800;
              margin: 0 0 10px 0;
              color: #1e293b;
              display: flex;
              align-items: center;
              gap: 10px;
            }

            .cube-card-badge {
              display: inline-block;
              padding: 4px 12px;
              border-radius: 20px;
              font-size: 12px;
              font-weight: 700;
              background: var(--badge-bg);
              color: var(--card-color);
              border: 2px solid var(--card-color);
            }

            .cube-card-description {
              font-size: 15px;
              color: #64748b;
              line-height: 1.6;
              margin: 0;
            }

            .cube-card-body {
              padding: 24px 28px 32px;
              background: linear-gradient(to bottom, #f8fafc 0%, white 100%);
            }

            .cube-card-button {
              width: 100%;
              padding: 16px;
              background: var(--card-gradient);
              color: white;
              border: none;
              border-radius: 12px;
              font-size: 16px;
              font-weight: 700;
              cursor: pointer;
              transition: all 0.3s;
              box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            }

            .cube-card-button:hover {
              transform: translateY(-2px);
              box-shadow: 0 8px 20px rgba(0,0,0,0.25);
            }

            .cube-card-button:active {
              transform: translateY(0);
            }

            /* Red Card */
            .cube-card.red {
              --card-color: #dc2626;
              --card-gradient: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
              --badge-bg: #fef2f2;
            }

            /* Blue Card */
            .cube-card.blue {
              --card-color: #2563eb;
              --card-gradient: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
              --badge-bg: #eff6ff;
            }

            /* Green Card */
            .cube-card.green {
              --card-color: #16a34a;
              --card-gradient: linear-gradient(135deg, #16a34a 0%, #22c55e 100%);
              --badge-bg: #f0fdf4;
            }

            /* Orange Card */
            .cube-card.orange {
              --card-color: #f59e0b;
              --card-gradient: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
              --badge-bg: #fffbeb;
            }

            @keyframes slideDown {
              from {
                opacity: 0;
                transform: translateY(-30px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            @keyframes fadeIn {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }

            @keyframes bounce {
              0%, 100% {
                transform: translateY(0);
              }
              50% {
                transform: translateY(-10px);
              }
            }

            @media (max-width: 768px) {
              .cubes-grid {
                grid-template-columns: 1fr;
              }

              .cube-card-icon {
                font-size: 48px;
              }

              .cube-card-title {
                font-size: 22px;
              }
            }
          `}</style>

          <div className="cubes-container">
            {/* المقدمة */}
            <div className="cubes-intro">
              <h2>
                <span>🧱</span>
                نظام إدارة المكعبات الخرسانية
              </h2>
              <p>
                متابعة شاملة لدورة حياة المكعبات الخرسانية من الصب إلى التكسير والنتائج
                - نظام متكامل مع إشعارات تلقائية وتقارير تفصيلية
              </p>
            </div>

            {/* شبكة الكروت */}
            <div className="cubes-grid">
              {/* كارت تكسير اليوم */}
              <div className="cube-card red">
                <div className="cube-card-header">
                  <span className="cube-card-icon">🔔</span>
                  <h3 className="cube-card-title">
                    تكسير اليوم
                    <span className="cube-card-badge">عاجل</span>
                  </h3>
                  <p className="cube-card-description">
                    المكعبات المطلوب تكسيرها اليوم مع نظام إشعارات تلقائي
                  </p>
                </div>
                <div className="cube-card-body">
                  <button 
                    className="cube-card-button"
                    onClick={() => navigate('/cubes/todays-breaking')}
                  >
                    📋 عرض التفاصيل
                  </button>
                </div>
              </div>

              {/* كارت اللوج */}
              <div className="cube-card blue">
                <div className="cube-card-header">
                  <span className="cube-card-icon">📋</span>
                  <h3 className="cube-card-title">
                    اللوج
                    <span className="cube-card-badge">8 محطات</span>
                  </h3>
                  <p className="cube-card-description">
                    سجل شامل لجميع المكعبات موزع حسب المحطات والأنواع
                  </p>
                </div>
                <div className="cube-card-body">
                  <button 
                    className="cube-card-button"
                    onClick={() => navigate('/cubes/log')}
                  >
                    📂 فتح السجل
                  </button>
                </div>
              </div>

              {/* كارت نتائج التكسير */}
              <div className="cube-card green">
                <div className="cube-card-header">
                  <span className="cube-card-icon">📊</span>
                  <h3 className="cube-card-title">
                    نتائج التكسير
                    <span className="cube-card-badge">تقارير</span>
                  </h3>
                  <p className="cube-card-description">
                    تسجيل وعرض نتائج اختبارات التكسير مع التحليلات
                  </p>
                </div>
                <div className="cube-card-body">
                  <button 
                    className="cube-card-button"
                    onClick={() => navigate('/cubes/results')}
                  >
                    📈 عرض النتائج
                  </button>
                </div>
              </div>

              {/* كارت التكسير القادم */}
              <div className="cube-card orange">
                <div className="cube-card-header">
                  <span className="cube-card-icon">📅</span>
                  <h3 className="cube-card-title">
                    التكسير القادم
                    <span className="cube-card-badge">7 أيام</span>
                  </h3>
                  <p className="cube-card-description">
                    متابعة تكسير غداً والأسبوع القادم مع إشعارات مسبقة
                  </p>
                </div>
                <div className="cube-card-body">
                  <button 
                    className="cube-card-button"
                    onClick={() => navigate('/cubes/upcoming')}
                  >
                    🔮 عرض القادم
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cubes;